import { render, staticRenderFns } from "./CompletarRegistroAdmin.vue?vue&type=template&id=94bcb046&"
import script from "./CompletarRegistroAdmin.vue?vue&type=script&lang=js&"
export * from "./CompletarRegistroAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports